import { cn } from '../lib/cn';

export interface AvatarProps {
  name: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE = { sm: 'h-8 w-8 text-xs', md: 'h-10 w-10 text-sm', lg: 'h-12 w-12 text-base' };

export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  const initials = name
    .split(' ')
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
  if (src) {
    return (
      <img src={src} alt="" className={cn('rounded-full object-cover', SIZE[size], className)} />
    );
  }
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-full bg-[var(--tenant-primary,#FFE600)] font-bold text-yhelp-black',
        SIZE[size],
        className,
      )}
      aria-hidden="true"
    >
      {initials}
    </span>
  );
}
